export default __webpack_public_path__ + "assets/parking-indoor/tallinn-telliskivi-building-large.605f40a12416991b2b602826fa9eff76.webp";